import { useCallback, useContext, useEffect, useState } from 'react';
import { InterfaceContext, validScaleByTime } from '../store/InterfaceProvider';
import { onemapSuggest, onemapFindAddress, getAddressCandidateScale } from '../requests/OneMapSearchRequest';
import { getFeatureByLonLat } from '../requests/FeatureServiceRequests';
import ReactAutocomplete from 'react-autocomplete';
// import { Tooltip, StandardTooltipWindow } from './Tooltip';

const SearchField = () => {
    const { setSearchResult, activeTimePeriod, activeViewType, setActiveScale, setSelectedFeature, setAppError, token } = useContext(InterfaceContext);
    const usExtent = [-172.96875, 14.604847, -60.117188, 72.711903];
    const [extent, setExtent] = useState(usExtent);
    const [value, setvalue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [justScrolled, setJustScrolled] = useState(false);
    const [keyedIndex, setKeyedIndex] = useState(0);
    const placeholder = 'City, County, State, or ZIP Code';
    const ariaLabel = 'Search using City, County, State, or ZIP Code';

    const mapOnemapSuggestions = useCallback((list) => {
        if (!list) return [];
        return list.map((item, i) => {
            return {
                id: i,
                origin: 'onemap',
                label: item.text,
                value: item.magicKey
            };
        });
    });

    const onInputEnter = (e) => {
        // const newHoveredIndex = Math.min(hoveredSelection + 1, suggestions.length);
        if (e.key === 'ArrowDown') {
            let downIndex = Math.max(0, Math.min(keyedIndex + 1, suggestions.length));
            setKeyedIndex(downIndex);
        }
        if (e.key === 'ArrowUp') {
            let downIndex = Math.max(0, Math.min(keyedIndex - 1, suggestions.length));
            setKeyedIndex(downIndex);
        }
        if (e.key == 'Enter') {
            setSelectedChoice(suggestions[keyedIndex]);
            e.target.blur();
        }
    };
    //close the menu and remove focus from dropdown
    const onWindowScroll = () => {
        setJustScrolled(true);
        document.activeElement.blur();
    };
    const getSuggestions = (value, extent) => {
        onemapSuggest(value, extent.join(',')).then((res) => {
            const mappedItems = mapOnemapSuggestions(res.data.suggestions);
            setSuggestions(mappedItems);
        });
    };
    const setSelectedChoice = async (obj) => {
        const addressResult = await onemapFindAddress(obj.value, extent).then((res) => res.data.candidates[0]);
        const searchedScale = getAddressCandidateScale(addressResult, activeViewType);
        const availableScale = validScaleByTime(activeTimePeriod, searchedScale);
        const feature = await getFeatureByLonLat({ x: addressResult.location.x, y: addressResult.location.y, time: activeTimePeriod, scale: availableScale, token }).catch((error) => {
            setAppError(true, 'SearchField', error);
            return false;
        });
        if (!feature) return setvalue(''); //on search error close dropdown empty search field
        setActiveScale(availableScale);
        setSelectedFeature(feature);
        setSearchResult(addressResult); //Have the last thing the map does
        setvalue('');
    };

    //Initial Render
    useEffect(() => {
        window.addEventListener('scroll', onWindowScroll);
        return () => window.removeEventListener('scroll', onWindowScroll);
    }, []);

    useEffect(() => {
        if (!value) {
            setSuggestions([]);
            return;
        }
        getSuggestions(value, extent);
    }, [value]);

    useEffect(() => {
        setKeyedIndex(0);
    }, [suggestions]);

    var open = !justScrolled && suggestions.length > 0;

    return (
        <>
            <div id="searchField" className="control">
                <label>Search</label>
                <div id="search" className={'field ' + (open ? 'open' : 'closed') + ' ind-' + keyedIndex}>
                    <div className="flexwrap ">
                        <ReactAutocomplete
                            items={suggestions}
                            inputProps={{ placeholder }}
                            getItemValue={(item) => item.label}
                            autoHighlight={false}
                            renderItem={(item, highlighted) => {
                                return (
                                    item && (
                                        <div key={item.id} id={'ind-' + item.id} className={'auto-item' + (highlighted || item.id === keyedIndex ? ' highlight' : '')} onMouseOver={() => setKeyedIndex(item.id)}>
                                            {item.label}
                                        </div>
                                    )
                                );
                            }}
                            value={value}
                            open={!justScrolled && suggestions.length > 0}
                            renderInput={(props) => {
                                return <input aria-label={ariaLabel} {...props} onKeyDown={onInputEnter} />;
                            }}
                            onChange={async (e) => {
                                setvalue(e.target.value);
                            }}
                            onSelect={async (value, obj) => {
                                setSelectedChoice(obj);
                            }}
                            onMenuVisibilityChange={(e) => {
                                //Reset scroll tracker when user clicks inside the input
                                setJustScrolled(false);
                            }}
                        />
                        <span className="icon search"></span>
                        {/* <Tooltip id={'search-tip'} tooltip={ariaLabel} window={<StandardTooltipWindow id={'search-tip'} text={TEXTS.controls.search_box.tooltip} />}>
                        <div className="reset icon-info"></div>
                    </Tooltip> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SearchField;
